import React, { useCallback } from 'react';

import Link from '@mui/material/Link';
import cx from 'classnames';
import { useTranslation } from 'react-i18next';

import { useStylesCommon } from 'components/scheduleDisplay/styles';
import { Feature, featureEnabled } from 'config/clients';
import { usePlayersProfileDialog } from 'containers/dialogs/PlayersProfile';
import { type ParticipantInterface } from 'typedefs/store/tmxTypes';

type PlayerLinkProps = Partial<ParticipantInterface> &
  Pick<ParticipantInterface, 'participantId' | 'participantName'> & {
    className?: string;
  };

export const PlayerLink: React.FC<React.PropsWithChildren<PlayerLinkProps>> = React.memo(
  ({ className, participantName, participantId, ...props }) => {
    const { classes } = useStylesCommon(false);
    const { t } = useTranslation();
    const profileEnabled = featureEnabled(Feature.PLAYER_PROFILES);
    const showProfileDialog = usePlayersProfileDialog();

    const handleSetProfileDialogPlayers = useCallback(() => {
      showProfileDialog([{ participantId, participantName, ...props }]);
    }, [participantId, participantName, props, showProfileDialog]);

    return (
      <div>
        {!profileEnabled ? (
          participantName
        ) : (
          <Link
            classes={{ root: classes.participantName }}
            className={cx(className)}
            component="button"
            underline="hover"
            variant="button"
            onClick={handleSetProfileDialogPlayers}
          >
            {participantName || t('notApplicable')}
          </Link>
        )}
      </div>
    );
  },
);

export default PlayerLink;
